import { render, staticRenderFns } from "./AdminRightsTooltip.vue?vue&type=template&id=6068288b"
import script from "./AdminRightsTooltip.vue?vue&type=script&lang=ts"
export * from "./AdminRightsTooltip.vue?vue&type=script&lang=ts"
import style0 from "./AdminRightsTooltip.vue?vue&type=style&index=0&id=6068288b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports